module.exports = __webpack_public_path__ + "static/the-great-gatsby-9f3922e8a12f99d2df3baab7c57a90fe.jpg";